/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Keyboard, Pagination, FreeMode, Navigation } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import 'swiper/css/keyboard'
import router from 'next/router'

const About = () => {
  const [isMobile, setIsMobile] = useState(false)
  useEffect(() => {
    setIsMobile(window.innerWidth <= 768)
  })

  const swiperStatesConfig = {
    modules: [FreeMode, Pagination, Navigation, Keyboard],
    pagination: { clickable: true },
    navigation: {
      nextEl: '.swiper-button-next-about',
      prevEl: '.swiper-button-prev-about'
    },
    spaceBetween: 60,
    keyboard: true,
    autoHeight: true,
    centeredSlides: true,
    roundLengths: true,
    loop: true
  }

  const swiperHeaderConfig = {
    modules: [FreeMode, Pagination, Navigation, Keyboard],
    pagination: { clickable: true },
    navigation: {
      nextEl: '.swiper-button-next-about',
      prevEl: '.swiper-button-prev-about'
    },
    spaceBetween: isMobile ? 0 : 60,
    keyboard: true,
    autoHeight: !isMobile,
    centeredSlides: !isMobile,
    roundLengths: true,
    loop: true
  }

  const imgCards = [
    { route: '', src: '/images/aboutus-welcome.png' },
    { route: '/', src: '/images/aboutus-wander.png' },
    { route: '/', src: '/images/aboutus-explore.png' },
    { route: '/', src: '/images/aboutus-delight.png' }
  ]

  const storeMapArray = [
    { href: '/stores?s=AL', code: 'al', name: 'Alabama', color: 'tan' },
    { href: '/stores?s=AR', code: 'ar', name: 'Arkansas', color: 'purple' },
    { href: '/stores?s=FL', code: 'fl', name: 'Florida', color: 'blue' },
    { href: '/stores?s=GA', code: 'ga', name: 'Georgia', color: 'gray' },
    { href: '/stores?s=IA', code: 'ia', name: 'Iowa', color: 'green' },
    { href: '/stores?s=IL', code: 'il', name: 'Illinois', color: 'tan' },
    { href: '/stores?s=IN', code: 'in', name: 'Indiana', color: 'purple' },
    { href: '/stores?s=KY', code: 'ky', name: 'Kentucky', color: 'blue' },
    { href: '/stores?s=LA', code: 'la', name: 'Louisiana', color: 'purple' },
    { href: '/stores?s=MI', code: 'mi', name: 'Michigan', color: 'blue' },
    { href: '/stores?s=MO', code: 'mo', name: 'Missouri', color: 'gray' },
    { href: '/stores?s=MS', code: 'ms', name: 'Mississippi', color: 'green' },
    { href: '/stores?s=NC', code: 'nc', name: 'North Carolina', color: 'tan' },
    { href: '/stores?s=OH', code: 'oh', name: 'Ohio', color: 'purple' },
    { href: '/stores?s=OK', code: 'ok', name: 'Oklahoma', color: 'blue' },
    { href: '/stores?s=SC', code: 'sc', name: 'South Carolina', color: 'gray' },
    { href: '/stores?s=TN', code: 'tn', name: 'Tennessee', color: 'green' },
    { href: '/stores?s=TX', code: 'tx', name: 'Texas', color: 'tan' },
    { href: '/stores?s=VA', code: 'va', name: 'Virginia', color: 'purple' },
    { href: '/stores?s=WV', code: 'wv', name: 'West Virginia', color: 'blue' }
  ]

  return (
    <div className="about" id="main-content">
      <div className='about__container'>
        <div className='about__header'>
          <div className='about__header-logo'>
            <div className='about__header-logo-text'>
              <div>
                <Image src={'/images/aboutus-logo.png'} alt='logo' height={77} width={250} />
              </div>
            </div>
            <Image src={'/images/bubbles.svg'} alt='bubbles' height={77} width={100} />
          </div>
          <section className='swiper__section about-carousel'>
            <Swiper {...swiperHeaderConfig} slidesPerView={'auto'}>
              {imgCards.map((image, i) => (
                <SwiperSlide key={i}>
                  {i === 0
                    ? (
                      <img alt="Pictures of pOpshelf stores" src={image.src} />
                      )
                    : (
                      <Link href={image.route}>
                        <img alt="Pictures of pOpshelf stores" src={image.src} />
                      </Link>
                      )}
                </SwiperSlide>
              ))}
            </Swiper>
            <div data-testid="swiper-prev-button" className="swiper-button-prev-about swiper-navbutton swiper-navbutton-prev"></div>
            <div data-testid="swiper-next-button" className="swiper-button-next-about swiper-navbutton swiper-navbutton-next"></div>
          </section>
          <div className='about__header-cards'>
            <img src='/images/aboutus-welcome.png' alt='welcome' />
            <Link href='/'>
              <img src='/images/aboutus-wander.png' alt='wander' />
            </Link>
            <Link href='/'>
              <img src='/images/aboutus-explore.png' alt='explore' />
            </Link>
            <Link href='/'>
              <img src='/images/aboutus-delight.png' alt='delight' />
            </Link>
          </div>
        </div>
        <div className='about__detail'>
          <div className='about__detail-heading'>
            <Link href='/news' className='about__link'>our mission</Link>
            <h3>make every day special</h3>
          </div>
          <div className='about__detail-content'>
            <div>We're pOpshelf. A stress-free shopping destination, just for you. We believe in bringing enjoyment back to shopping by making it easy to get things you need and fun to find things you want.</div>
            <div>We've got every reason to shop. From party supplies, to DIY finds, surprises for the kids, trending beauty, and more. No matter what it is, you'll find the thing you need. And a few things you didn't know you wanted.</div>
            <div>Everything we do, we put our heart into it. It's that simple. Our helpful team members are there when you need them. And not when you don't.</div>
          </div>
        </div>
        <div className='about__explore'>
          <div className='about__explore-heading'>
            <Link href='/' className='about__link'>our collections</Link>
            <div>
              <h3>expl</h3><span>o</span><h3>re & discover</h3>
            </div>
          </div>
          <div className='about__explore-button responsive__large-mobile'>
            <button className='btn__primary' onClick={() => router.push('/categories')}>VIEW CATEGORIES</button>
          </div>
          <div className='about__explore-content'>
            <div>
              <Link href='/c/home'>
                  <img src='/images/about-us/home-decor.png' alt='home decor' />
                  <p>home decor</p>
              </Link>
            </div>
            <div>
              <Link href='/c/kitchen'>
                  <img src='/images/about-us/kitchen.jpg' alt='kitchen' />
                  <p>kitchen</p>
              </Link>
            </div>
            <div>
              <Link href='/c/party-occasion'>
                  <img src='/images/about-us/party.png' alt='party & celebration' />
                  <p>party & celebration</p>
              </Link>
            </div>
            <div>
              <Link href='/c/arts-crafts'>
                  <img src='/images/about-us/arts.jpg' alt='arts & crafts' />
                  <p>arts & crafts</p>
              </Link>
            </div>
            <div>
              <Link href='/c/health-wellness'>
                  <img src='/images/about-us/beauty.png' alt='health & wellness' />
                  <p>beauty & wellness</p>
              </Link>
            </div>
            <div>
              <Link href='/c/household'>
                  <img src='/images/about-us/household.jpg' alt='household' />
                  <p>household & cleaning</p>
              </Link>
            </div>
            <div>
              <Link href='/c/office-school-supplies'>
                  <img src='/images/about-us/office.png' alt='office & school supplies' />
                  <p>office & school supplies</p>
              </Link>
            </div>
            <div>
              <Link href='/c/electronics'>
                  <img src='/images/about-us/electronics.png' alt='electronics' />
                  <p>electronics</p>
              </Link>
            </div>
            <div>
              <Link href='/c/toys-1'>
                  <img src='/images/about-us/toys.png' alt='toys' />
                  <p>toys</p>
              </Link>
            </div>
            <div>
              <Link href='/c/market'>
                  <img src='/images/about-us/market.jpg' alt='market' />
                  <p>market</p>
              </Link>
            </div>
            <div>
              <Link href='/c/pet'>
                  <img src='/images/about-us/pet.png' alt='pet' />
                  <p>pet</p>
              </Link>
            </div>
            {/* </div> */}
          </div>
          <div className='about__explore-button responsive__large-desktop'>
            <button className='btn__primary' onClick={() => router.push('/categories')}>VIEW CATEGORIES</button>
          </div>
        </div>
      </div>

      <div className='about__stores'>
        <Link href='/stores' className='about__link'>+220 stores</Link>
        <div className='about__stores-heading'>
          <h3>we can't wait to meet you</h3>
        </div>
        <div className='about__stores-bg'>
          <div className='about__stores-content'>
            <div className='about__stores-button responsive__large-mobile'>
              <button className='btn__primary' onClick={() => router.push('/stores')}>FIND YOUR STORE</button>
            </div>
            <div className='about__stores-carousel'>
              <section className='swiper__section about__carousel'>
                <Swiper {...swiperStatesConfig} slidesPerView={'auto'}>
                  {storeMapArray.map((image, i) => (
                    <SwiperSlide key={i}>
                      <div className={`carousel__color-${image.color}`}>
                        <span>
                          <Link href={`${image.href}`}>
                              <p>{image.code}</p>
                              <p>{image.name}</p>
                            </Link>
                        </span>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                <div data-testid="swiper-prev-button" className="swiper-button-prev-about swiper-navbutton swiper-navbutton-prev"></div>
                <div data-testid="swiper-next-button" className="swiper-button-next-about swiper-navbutton swiper-navbutton-next"></div>
              </section>
            </div>
            <div className='about__stores-table'>
              <div>
                <span>
                  <Link href={'/stores?s=AL'}>
                      <p>al</p>
                      <p>Alabama</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s=AR'}>
                      <p>ar</p>
                      <p>Arkansas</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s=FL'}>
                      <p>fl</p>
                      <p>Florida</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s=GA'}>
                      <p>ga</p>
                      <p>Georgia</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s=IA'}>
                      <p>ia</p>
                      <p>Iowa</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s=IL'}>
                      <p>il</p>
                      <p>Illinois</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s='}>
                      <p>in</p>
                      <p>Indiana</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s=KY'}>
                      <p>ky</p>
                      <p>Kentucky</p>
                    </Link>
                </span>
              </div>
              <div>
                <span>
                  <Link href={'/stores?s=LA'}>
                      <p>la</p>
                      <p>Lousiana</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s='}>
                      <p>mi</p>
                      <p>Michigan</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s=MO'}>
                      <p>mo</p>
                      <p>Missouri</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s=MS'}>
                      <p>ms</p>
                      <p>Mississippi</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s=NC'}>
                      <p>nc</p>
                      <p>North Carolina</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s=OH'}>
                      <p>oh</p>
                      <p>Ohio</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s=OK'}>
                      <p>ok</p>
                      <p>Oklahoma</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s=SC'}>
                      <p>sc</p>
                      <p>South Carolina</p>
                    </Link>
                </span>
              </div>
              <div>
                <span><a></a></span>
                <span><a></a></span>
                <span>
                  <Link href={'/stores?s=TN'}>
                      <p>tn</p>
                      <p>Tennessee</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s=TX'}>
                      <p>tx</p>
                      <p>Texas</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s=VA'}>
                      <p>va</p>
                      <p>Virginia</p>
                    </Link>
                </span>
                <span>
                  <Link href={'/stores?s=WV'}>
                      <p>wv</p>
                      <p>West Virginia</p>
                    </Link>
                </span>
                <span><a></a></span>
                <span><a></a></span>
              </div>
            </div>
          </div>
          <div className='about__stores-button responsive__large-desktop'>
            <button className='btn__primary' onClick={() => router.push('/stores')}>FIND YOUR STORE</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export const getServerSideProps = async () => {
  return {
    props: {

    }
  }
}

export default About
